import { Injectable } from '@angular/core';
import { JavaService } from './java.service';
import * as _ from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class FlaskService {

    // TODO: make configurable
    trvegas = 'http://api.freedomgw.com:800/api/tr';
    vegas = 'https://api.freedomgw.com/api/api/ping';
    base = 'http://localhost:8000/api/tr';
    fgtest = 'https://fgtest.moneroatm.xyz/api';
    // base = this.trvegas;

    constructor(
        private _java: JavaService,
    ) {
        console.log(this);
    }

    /**
     * @ignore
     * only used in testing
     */
    createMachine() {
        const endpoint = `${this.fgtest}/api/addnewmachine`;
        const json = {
            'Organization ID': '00002',
            Username: 'Maya',
            //      Password: 'MayaPass1',
        };
        const res = this.post(endpoint, json);

        return res;
    }

    /**
     * @ignore
     * only used in testing
     */
    getSessionKey() {
        const endpoint = `${this.fgtest}/api/security/get_new_session_key`;
        const json = {
            'Machine ID': '00001-001-1-00001',
            'Machine PK': '71dc37e6810b4ce2502962ca6a192ff46587173ea607dc333fedbdb0e0711c2a020d644a4a2b99e208f57e9d00c49958144d97cd69fd4c4bf36245b991072616',
            // 'Machine PK': 'c7c21492e61475f63a9171d3e29767dc3d67facac90431bae066c88dbda5bcfef7b8067afe604e78b768c12fa8340bb0d5715ec253b807d83a862729e0caeac9', // 2-2-2-1
            // 'Machine PK': '29862838513ef4974477a2c224d355415c1e239437a87fea90d00b304d67b8819337120951ff18178eb85e0e8310b8c79ffed5041f32c445947c93f4691afb5c', // 2-2-2-2
        };
        const res = this.post(endpoint, json);

        return res['Machine Session'];
    }

    /**
     * @ignore
     * only used in testing
     */
    testRequest() {
        const endpoint = `${this.fgtest}/api/security/test_request`;
        const json = {};
        const res = this.post(endpoint, json);

        return res;
    }

    /**
     * get identity
     */
    getIdentity(phone: string) {
        const endpoint = `${this.fgtest}/api/get_identity`;
        const json = {
            "Phone Number": phone,
        };
        const res = this.post(endpoint, json);

        return res['Identity'];
    }

    /**
     * check name
     */
    checkName(identity: string) {
        const endpoint = `${this.fgtest}/api/check_identity_data`;
        const json = {
            "Identity": identity,
            "Data Point": "Name",
        };
        const res = this.post(endpoint, json);

        return res['Data Point Exists'];
    }

    /**
     * get accounttier
     */
    getAccountTier(id: string) {
        const endpoint = `${this.fgtest}/api/getaccounttier`;
        const json = {
            // "Machine ID": "00001-001-1-00001",
            "Identity ID": id,
            // "Session Key": "..."
        };
        const res = this.post(endpoint, json);

        return res;
    }

    /**
     * gets price for coin
     */
    priceOracle(coin: string) {
        const endpoint = `${this.fgtest}/api/price_oracle`;
        const json = {
            // "Machine ID": "00001-001-1-00001",
            "Cryptos": [coin],
            // "Session Key": "..."
        };
        const res = this.post(endpoint, json).Prices[coin];

        return res;
    }

    /**
     * first step in sell flow
     */
    makeRequestAddress(identity: string, crypto: string, amount: number) {
        const endpoint = `${this.fgtest}/api/makerequestaddress`;

        // FIXME: py should handle this
        const limits = this.getAccountTier(identity);
        const { Name, Phone_Number } = limits;

        const json = {
            // "Machine ID": "00001-001-1-00001",
            "Identity ID": identity,
            "Crypto": crypto,
            "Amount": amount,
            // "Session Key": "..."

            // FIXME: should not be needed eventually
            Name,
            "Phone Number": Phone_Number,
        };
        const res = this.post(endpoint, json);

        return res['Request QR'];
    }

    /**
     * second step of sell flow
     */
    checkRedemption(code: string) {
        const endpoint = `${this.fgtest}/api/checkredemptioncodestatus`;

        // FIXME: py should handle this
        //    const limits = this.getAccountTier(identity);
        //  const { Name, Phone_Number } = limits;

        const json = {
            'Redemption Code ID': code,
        };
        const res = this.post(endpoint, json);

        return res;
    }

    /**
     * final step of sell flow
     */
    updateRedemption(code: string, remaining: number) {
        const endpoint = `${this.fgtest}/api/updateredemptioncodestatus`;
        const json = {
            'Redemption Status': remaining ? 'Partially Paid' : 'Fully Paid',
            'Amount Remaining': remaining,
            'Code Status': 'Valid',
            'Redemption Code ID': code,
        };
        const res = this.post(endpoint, json);

        return res;
    }

    /**
     * used to lock TR admin
     */
    setPin(pin: string) {
        return this.post(`${this.base}/pin`, { pin });
    }

    /**
     * used to lock TR admin
     */
    getPin() {
        const jc = this._java.javaConnector;
        const s = (jc.sendGet(`${this.base}/pin`));
        const res = JSON.parse(s);

        return res['pin'] || '';
    }

    /**
     * @ignore
     * send post through java
     */
    private post(url: string, json: any) {
        const jc = this._java.javaConnector;
        const res = jc.sendPost(url, JSON.stringify(json));

        return JSON.parse(res);
    }
}
